import { clone, min, omit, pick } from 'radash'
import type { RouteRecordRaw } from 'vue-router'
import type { MenuOption } from 'naive-ui'
import { local } from './storage'
import BasicLayout from '@/layout/BasicLayout.vue'

const metaFields: AppRoute.MetaKeys[]
  = ['title', 'icon', 'requiresAuth', 'hide', 'order', 'href', 'activeMenu', 'withoutTab', 'pinTab', 'menuType', 'role']
function standardizedRoutes(route: AppRoute.RowRoute[]) {
  return clone(route).map((i) => {
    const route = omit(i, metaFields)
    Reflect.set(route, 'meta', pick(i, metaFields))
    return route
  }) as AppRoute.Route[]
}
function arrayToTree(arr: any[]) {
  const res: any = []
  const map = new Map()
  arr.forEach((item) => {
    map.set(item.id, item)
  })
  arr.forEach((item) => {
    const parent = item.pid && map.get(item.pid)
    if (parent) {
      if (parent?.children)
        parent.children.push(item)
      else
        parent.children = [item]
    }
    else {
      res.push(item)
    }
  })

  return res
}
export function createRoutes(routes: AppRoute.RowRoute[]) {
  // Structure the meta field
  let resultRouter = standardizedRoutes(routes)
  // Generate routes, no need to import files for those with redirect
  const modules = import.meta.glob('@/view/**/*.vue')
  resultRouter = resultRouter.map((item: AppRoute.Route) => {
    if (item.componentPath && !item.redirect)
      item.component = modules[`/src/view${item.componentPath}`]
    return item
  })
  // Generate route tree
  resultRouter = arrayToTree(resultRouter) as AppRoute.Route[]

  const appRootRoute: RouteRecordRaw = {
    path: '/',
    name: '/',
    redirect: import.meta.env.VITE_HOME_PATH,
    component: BasicLayout,
    meta: {
      title: '',
      icon: 'icon-park-outline:home',
    },
    children: [],
  }

  // Set the correct redirect path for the route
  setRedirect(resultRouter)

  // Insert the processed route into the root route
  appRootRoute.children = resultRouter as unknown as RouteRecordRaw[]
  console.log(appRootRoute)
  return appRootRoute
}
function setRedirect(routes: AppRoute.Route[]) {
  routes.forEach((route) => {
    if (route.children) {
      if (!route.redirect) {
        // Filter out a collection of child elements that are not hidden
        const visibleChilds = route.children.filter(child => !child.meta.hide)

        // Redirect page to the path of the first child element by default
        let target = visibleChilds[0]

        // Filter out pages with the order attribute
        const orderChilds = visibleChilds.filter(child => child.meta.order)

        if (orderChilds.length > 0)
          target = min(orderChilds, i => i.meta.order!) as AppRoute.Route

        if (target)
          route.redirect = target.path
      }

      setRedirect(route.children)
    }
  })
}
/* 生成侧边菜单的数据 */
export function createMenus(userRoutes: AppRoute.RowRoute[]) {
  const resultMenus = standardizedRoutes(userRoutes)
  // filter menus that do not need to be displayed
  const visibleMenus = resultMenus.filter(route => !route.meta.hide && (route.meta.role ? route.meta.role.includes(local.get('userInfo').type) : true))
  // console.log(visibleMenus)
  // return arrayToTree(transformAuthRoutesToMenus(visibleMenus))
  return transformAuthRoutesToMenus(visibleMenus)
}
function transformAuthRoutesToMenus(userRoutes: AppRoute.Route[]) {
  // Filter out side menus without permission
  return userRoutes
    .map((item) => {
      const target: MenuOption = {
        id: item.id,
        name: item.name,
        pid: item.pid,
        label: item.meta.title,
        key: item.path,
      }
      return target
    })
}
